import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ExperiencePerformanceTypes, ExperienceTypes, visibilityChangeObserver } from '@atlassian/ufo-experimental';
import { getGlobalEventStream, setGlobalEventStream as _setGlobalEventStream } from '@atlassian/ufo-experimental/global-stream-buffer';
import { ufolog, ufowarn } from '@atlassian/ufo-experimental/logger';
import { PageVisibleState, UFOGlobalEventStreamEventType } from '@atlassian/ufo-experimental/types';
import { UFO_BUILD_VERSION } from '../../buildVersion';
import { TenantType } from '../../types';
import { UFOGlobalEventStream } from '../event-stream/event-stream';
import { getPerformancePayload } from './performance';
import { pageVisibleState } from './performance/plugins/page-visible-state';
import { resourceTimingBuffer } from './performance/resource-timings-buffer';
import { appFramework } from './plugins/app/framework';
import { appVersion } from './plugins/app/version';
import { eventBrowserPlugin } from './plugins/browser';
import { eventCpusPlugin } from './plugins/cpus';
import { featureFlags } from './plugins/feature-flags';
import { eventMemoryPlugin } from './plugins/memory';
import { eventNetworkPlugin } from './plugins/network';
import { ssrFeatureFlags } from './plugins/ssr/feature-flags';
import { ssrSuccess } from './plugins/ssr/success';
import { Route } from './route';
import { isInitialPageLoad } from './utils/is-initial-page-load';
import { getPerformanceObject, getWindowObject } from './utils/window-helper';
var UNKNOWN_VALUE = 'unknown';
var DEFAULT_PAYLOAD_DATA = {
  schemaVersion: UNKNOWN_VALUE,
  id: UNKNOWN_VALUE,
  uuid: UNKNOWN_VALUE,
  state: {
    id: UNKNOWN_VALUE
  },
  result: {
    startTime: 0,
    duration: 0,
    success: false
  },
  type: ExperienceTypes.Experience,
  category: UNKNOWN_VALUE,
  performanceType: ExperiencePerformanceTypes.Custom,
  metadata: {},
  explicitTimings: {},
  metrics: {
    startTime: 0,
    endTime: 0,
    marks: []
  },
  platform: null,
  children: [],
  pageVisibleState: PageVisibleState.MIXED,
  isSSROutputAsFMP: false,
  timings: [],
  featureFlags: []
};
var Publisher = /*#__PURE__*/function () {
  function Publisher() {
    var _getWindowObject,
      _this = this;
    _classCallCheck(this, Publisher);
    _defineProperty(this, "gasv3", null);
    _defineProperty(this, "product", '');
    _defineProperty(this, "region", UNKNOWN_VALUE);
    _defineProperty(this, "hostname", ((_getWindowObject = getWindowObject()) === null || _getWindowObject === void 0 || (_getWindowObject = _getWindowObject.location) === null || _getWindowObject === void 0 ? void 0 : _getWindowObject.hostname) || '');
    _defineProperty(this, "tenantType", TenantType.RealUser);
    _defineProperty(this, "app", {
      version: {
        web: UNKNOWN_VALUE
      }
    });
    _defineProperty(this, "performanceConfig", {});
    _defineProperty(this, "buffer", []);
    _defineProperty(this, "featureFlagClient", null);
    _defineProperty(this, "featureFlags", []);
    _defineProperty(this, "ssr", null);
    _defineProperty(this, "resourceTimings", null);
    _defineProperty(this, "bundleEvalTimings", null);
    _defineProperty(this, "route", Route);
    _defineProperty(this, "plugins", null);
    _defineProperty(this, "allowlist", function () {
      return true;
    });
    _defineProperty(this, "getPluginsMetrics", function (data) {
      var result = {};
      if (_this.plugins) {
        _this.plugins.forEach(function (plugin) {
          var pluginOutput = plugin(_objectSpread({}, data));
          if (pluginOutput === null || _typeof(pluginOutput) !== 'object') {
            return;
          }
          Object.entries(pluginOutput).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];
            result["".concat(_this.product, ":").concat(key)] = value;
          });
        });
      }
      return result;
    });
  }
  _createClass(Publisher, [{
    key: "publish",
    value: function publish(data) {
      var _getPerformanceObject, _getPerformanceObject2;
      var payloadStart = ((_getPerformanceObject = getPerformanceObject()) === null || _getPerformanceObject === void 0 ? void 0 : _getPerformanceObject.now()) || 0;
      var experienceKey = this.getExperienceKey(data);
      if (!this.allowlist(experienceKey, data)) {
        ufowarn("experience ".concat(experienceKey, " does not meet requirements of allowlist"));
        return;
      }

      // it is used to setup default properties on the data to prevent errors
      var supportedData = _objectSpread(_objectSpread({}, DEFAULT_PAYLOAD_DATA), data);
      var payload = {
        actionSubject: 'experience',
        action: 'measured',
        source: 'measured',
        tags: ['observability'],
        attributes: {
          properties: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
            'event:source': {
              name: 'ufo/web',
              version: supportedData.schemaVersion
            },
            'event:schema': UFO_BUILD_VERSION || UNKNOWN_VALUE,
            'event:product': this.product,
            'event:region': this.region,
            'event:hostname': this.hostname,
            'event:route': this.route.getRoute()
          }, eventBrowserPlugin()), eventCpusPlugin()), eventMemoryPlugin()), eventNetworkPlugin()), appFramework(this.app)), appVersion(this.app)), {}, {
            'experience:name': supportedData.id,
            // platform.fe.page-load|interaction|custom|page-segment.editor
            'experience:key': experienceKey,
            'experience:status': supportedData.state.id,
            'experience:duration': supportedData.result.duration
          }, supportedData.result.startTime !== null ? {
            'experience:startTime': supportedData.result.startTime
          } : null), supportedData.uuid ? {
            'experience:spanId': supportedData.uuid
          } : null), this.tenantType !== TenantType.RealUser ? {
            'event:tenantType': this.tenantType
          } : null), this.mapMetadataToPayload(supportedData.metadata)), this.extractPageLoadData(supportedData)), pageVisibleState(supportedData)), isInitialPageLoad(supportedData) && ssrSuccess(this.ssr)), isInitialPageLoad(supportedData) && ssrFeatureFlags(this.ssr)), this.featureFlagClient && featureFlags(this.featureFlagClient, this.featureFlags, supportedData)),
          performance: this.getPerformanceMetrics(supportedData),
          task: supportedData.id
        }
      };
      var payloadEnd = ((_getPerformanceObject2 = getPerformanceObject()) === null || _getPerformanceObject2 === void 0 ? void 0 : _getPerformanceObject2.now()) || 0;
      payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
      if (this.gasv3) {
        this.gasv3.sendOperationalEvent(payload);
      } else {
        this.buffer.push(payload);
      }
      ufolog('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
  }, {
    key: "setGlobalEventStream",
    value: function setGlobalEventStream() {
      if (!(getGlobalEventStream() instanceof UFOGlobalEventStream)) {
        var eventStream = new UFOGlobalEventStream();
        eventStream.push({
          type: UFOGlobalEventStreamEventType.SUBSCRIBE,
          payload: {
            experienceId: '__SUBSCRIBE_ALL__',
            callback: this.publish.bind(this)
          }
        });
        _setGlobalEventStream(eventStream);
      }
    }
  }, {
    key: "setRoute",
    value: function setRoute(newRoute) {
      this.route.setRoute(newRoute);
    }
  }, {
    key: "setup",
    value: function setup(config) {
      visibilityChangeObserver.start();
      resourceTimingBuffer.start();
      if (!this.product) {
        this.product = config.product || '';
      }
      if (config.allowlist) {
        this.allowlist = config.allowlist;
      }
      if (config.tenantType) {
        this.tenantType = config.tenantType;
      }
      if (config.hostname) {
        this.hostname = config.hostname;
      }
      if (config.region) {
        this.region = config.region;
      }
      if (config.app) {
        this.app = config.app;
      }
      if (config.featureFlagClient) {
        this.featureFlagClient = config.featureFlagClient;
      }
      if (config.featureFlags) {
        this.featureFlags = config.featureFlags;
      }
      if (config.ssr) {
        this.ssr = config.ssr;
      }
      if (config.bundleEvalTimings) {
        this.bundleEvalTimings = config.bundleEvalTimings;
      }
      if (config.resourceTimings) {
        this.resourceTimings = config.resourceTimings;
      }
      if (config.performanceConfig) {
        this.performanceConfig = config.performanceConfig;
      }
      if (config.plugins) {
        this.plugins = config.plugins;
      }
      this.setGlobalEventStream();
      if (!this.gasv3) {
        this.gasv3 = config.gasv3;
        this.buffer.forEach(this.gasv3.sendOperationalEvent);
      }
    }
  }, {
    key: "mapMetadataToPayload",
    value: function mapMetadataToPayload(metadata) {
      var payload = {};
      Object.entries(metadata).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        if (value !== undefined) {
          payload["custom:".concat(key)] = value;
        }
      });
      return payload;
    }
  }, {
    key: "extractPageLoadData",
    value: function extractPageLoadData(data) {
      if ('initial' in data) {
        return {
          'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
      }
      return {};
    }
  }, {
    key: "getPrefix",
    value: function getPrefix(data) {
      if (data.platform !== null) {
        return 'platform';
      }
      return this.product;
    }
  }, {
    key: "getExperienceKey",
    value: function getExperienceKey(data) {
      var keyParts = [this.getPrefix(data), 'fe', data.type];
      if (data.platform) {
        keyParts.push(data.platform.component);
      }
      keyParts.push(data.id);
      return keyParts.join('.');
    }
  }, {
    key: "getExperiencePerformanceKey",
    value: function getExperiencePerformanceKey(data) {
      var keyParts = [this.getPrefix(data), 'fe', data.performanceType];
      if (data.platform) {
        keyParts.push(data.platform.component);
      }
      keyParts.push(data.id);
      return keyParts.join('.');
    }
  }, {
    key: "getExperiencePerformanceType",
    value: function getExperiencePerformanceType(data) {
      return data.performanceType;
    }
  }, {
    key: "getPerformanceMetrics",
    value: function getPerformanceMetrics(data) {
      return _objectSpread(_objectSpread({
        'event:key': this.getExperiencePerformanceKey(data),
        'event:type': this.getExperiencePerformanceType(data)
      }, getPerformancePayload(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig)), this.getPluginsMetrics(data));
    }
  }]);
  return Publisher;
}();
export var payloadPublisher = new Publisher();